class Pie extends Chart {
  constructor(config) {
    super(config);
    this.svg;
    this.x;
    this.y;
    this.radius;    
    this.innerRadius = config.innerRadius || 100;
    this.outerRadius = config.outerRadius || 20;
    this.color = config.color || d3.scaleOrdinal(d3.schemeCategory10);
    this.resultField = config.resultField || 'rvalue';
    this.categoryField = config.categoryField || 'category';
    this.pie = d3.pie().value(d => d[this.resultField]);
  }

  /**
   * This method is used to create the SVG that all of the other chart elements will be appended to
   * @return {object} [returns Heatmap]
   */
  createSVG() {
    const { container } = this;
    const chartDimensions = this.setChartDimensions();
    const { width, height, margin } = chartDimensions;

    let containerWidth = d3.select(container).style('width')
    containerWidth = parseInt(containerWidth.substring(0, containerWidth.length - 2));

    this.removeSVG();
    const svg = d3.select(this.container)
      .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height)
        .attr('id', 'd3-graph')
        .style('overflow', 'visible')
      .append('g')
        .attr('transform', `translate(${(containerWidth)/2},${height/2})`);
    this.svg = svg;
    return this;
  } // createSVG

  calcRadius() {
    const { width, height } = this.chartDimensions;
    this.radius = Math.min(width, height) / 2;
    return this;
  }

  calcArc() {
    this.arc = d3.arc()
      .innerRadius(this.radius - this.innerRadius)
      .outerRadius(this.radius - this.outerRadius);
    return this;
  }

  createPieSegments() {
    const { svg, data, color, arc, pie } = this;
    svg.datum(data).selectAll('path')
      .data(pie)
    .enter().append('path')
      .attr('fill', (d, i) => color(i))
      .attr('d', arc)
      .each(function(d) { this._current = d; }); // store the initial angles
    return this;
  }

  createPieText() {
    const { arc, svg, pie, resultField } = this;
    const text = svg.selectAll('text')
        .data(pie)
      .enter().append('text')
        .attr('transform', d => `translate(${arc.centroid(d)})`)
        .attr('dy', '0.35em');
    
    text.append('tspan')
      .attr('x', '-0.4em')
      .attr('y', 0)
      .style('font-weight', 'bold')
      .style('font-size', '1.4rem')
      .style('text-align', 'center')
      .style('fill', '#FFF')
      .text(d => `${d.data[resultField]}%`);
    return this;
  }

  createLegend() {
    const { container, data, color, categoryField } = this;

    const legend = d3.select(container).append('div')
      .attr('class', 'funding-legend');

    const legendItems = d3.select('.funding-legend')
      .selectAll('.funding-legend-item').data(data);

    legendItems.enter()
      .append('div').attr('class', 'funding-legend-item')
      .style('margin-top', '25px');
    
      d3.selectAll('.funding-legend-item').append('div')
      .attr('class', 'funding-legend-rect')
      .style('width', '40px')
      .style('height', '20px')
      .style('background-color', (d, i) => color(i));

    d3.selectAll('.funding-legend-item').append('div')
      .attr('class', 'funding-legend-text')
      .text(d => d[categoryField]);
  }

  draw() {
    this
      .validateConfig()
      .createSVG()
      .calcRadius()
      .calcArc()
      .createPieSegments()
      .createPieText()
      .createLegend();
    return this;
  } // draw()
}